import React from 'react';
import withPriceData, { IInjectedPriceProps } from '../../../hoc/withPriceData';
import { IProduct } from '../../../types';

interface IPriceContainerProps {
  product: IProduct;
}

type Props = IPriceContainerProps & IInjectedPriceProps;

const PriceContainer = ({ product, priceData }: Props) => {
  if (!product) {
    return null;
  }

  return (
    <div className={`price-wrapper${priceData.isPromo ? ' promo' : ''}`}>
      <div
        className={`current-price${
          priceData.isPromo ? ' current-price__promo' : ''
        }`}
      >
        {priceData.price}
      </div>
      {priceData.isPromo && (
        <div className="regular-price promo">{priceData.defaultPrice}</div>
      )}
    </div>
  );
};

export default withPriceData(PriceContainer);
